import { render } from "./headerOffre.vue?vue&type=template&id=3ff955b2"
import script from "./headerOffre.vue?vue&type=script&lang=ts"
export * from "./headerOffre.vue?vue&type=script&lang=ts"
script.render = render

export default script